import { Badge, Dropdown } from "react-bootstrap";
import locationIcon from "../../../../Assets/Icons/location-pin.png";
import EditIcon from "../../../../Assets/Icons/icon-edit.png";
import DeleteIcon from "../../../../Assets/Icons/icon-delete.png";

const DeliveryAddressCard = ({
    address,
    selectedAddressId,
    handleAddressSelect,
    changeDeliveryAddress,
    handleCloseUpdateModal,
    handleDeleteAddress,
    handleUpdateDefaultAddress,
    showAddressError,
    handleShowAddressModal
}) => {
    return (
        <div className="checkOutCard">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between">
                        <div>
                            <h4 className="fw-bold pb-4">
                                Delivery Address
                            </h4>
                        </div>
                        <div className="d-flex align-items-start justify-content-end">
                            <button
                                className="btn text-danger"
                                onClick={handleShowAddressModal}
                            >
                                + Add address
                            </button>
                        </div>
                    </div>

                    <div className="deliveryDetails">
                        <div className="d-flex locaionDetails">
                            {/* <div className='d-flex align-items-start'>
                              <img
                                src={locationIcon}
                                alt=''
                                style={{ width: '1.5rem' }}
                              />
                            </div> */}
                            <div className="d-flex flex-column addressCheckOut">
                                {address.length !== 0 ? (
                                    <h5 className="text-black-50">
                                        Saved Addresses
                                    </h5>
                                ) : (
                                    <h5 className="text-black-50">
                                        Enter New Address
                                    </h5>
                                )}
                                <div className="AddressCard">
                                    <div className="scrollable-addresses">
                                        <div
                                            className="scrollable-container"
                                            style={{
                                                maxHeight: "300px",

                                                // overflowY: 'auto',
                                            }}
                                        >
                                            {address?.map((address, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        margin: "0",
                                                        border:
                                                            selectedAddressId ===
                                                                address.id
                                                                ? // address.isDefault
                                                                "2px solid black"
                                                                : "none",
                                                    }}
                                                    className="checkOutCard m-2 d-flex"
                                                    onClick={() => {
                                                        handleAddressSelect(address.id);
                                                        changeDeliveryAddress(address);
                                                    }}
                                                >
                                                    <div>
                                                        <img
                                                            src={locationIcon}
                                                            alt=""
                                                            style={{ width: "1.5rem" }}
                                                        />
                                                    </div>
                                                    <div className="ps-2">
                                                        {/* <div>
                                                    <h5>Work</h5>
                                                  </div> */}
                                                        <div>
                                                            <h6>{address.address}</h6>
                                                        </div>
                                                        <div>
                                                            <h5>
                                                                <Badge pill bg="info">
                                                                    {address.tag}
                                                                </Badge>
                                                            </h5>
                                                        </div>
                                                        <div className="mt-2">
                                                            <p>
                                                                Note to rider:{" "}
                                                                {address.noteForDeliveryMan}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="d-flex flex-row gap-2"
                                                        style={{ marginLeft: "auto" }}
                                                    >
                                                        <div
                                                            className="flex-grow-1"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleCloseUpdateModal(
                                                                    address
                                                                );
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={EditIcon}
                                                                alt=""
                                                                style={{ width: "1.4rem" }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="flex-grow-1"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteAddress(
                                                                    address.id
                                                                );
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={DeleteIcon}
                                                                alt=""
                                                                style={{ width: "1.5rem" }}
                                                            />
                                                        </div>
                                                        {!address.isDefault && (
                                                            <Dropdown className="flex-grow-1 ">
                                                                <Dropdown.Toggle
                                                                    variant="success"
                                                                    id="dropdown-basic"
                                                                    className="d-flex bg-transparent border-0"
                                                                >
                                                                    <div className="dot"></div>
                                                                    <div className="dot"></div>
                                                                    <div className="dot"></div>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            handleUpdateDefaultAddress(
                                                                                address.id,
                                                                                address.userId
                                                                            )
                                                                        }
                                                                    >
                                                                        Set as default
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            {showAddressError && (
                                                <p className="text-danger ps-2 pt-2">
                                                    Please select or provide an
                                                    address
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    {/* <h5 style={{ padding: '0', margin: '0' }}>
                                 
                                </h5>
                                <h6
                                  className="city"
                                  style={{ padding: "0", margin: "0" }}
                                >
                                  UK
                                </h6> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeliveryAddressCard;